<!-- <ridango-navigation-bar>
    <ul role="navigation">
        <li>
            <a [routerLink]="'/account/related-cards' | localize" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: false }">
                {{'MY_ACCOUNT_CARDS_ACTIVE_TICKETS' | translate}}
            </a>
        </li>

        <li>
            <a [routerLink]="'/account/purchase-history' | localize" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: false }">
                {{'MY_ACCOUNT_PURCHASE_HISTORY' | translate}}
            </a>
        </li>

        <li>
            <a [routerLink]="'/account/favourite-journeys' | localize" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: false }">
                {{'MY_ACCOUNT_FAVORITE_JOURNEYS' | translate}}
            </a>
        </li>

        <li>
            <a aria-current="page" [routerLink]="'/account/profile' | localize" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: false }">
                {{'MY_ACCOUNT_PROFILE' | translate}}
            </a>
        </li>
    </ul>
</ridango-navigation-bar> -->
<router-outlet></router-outlet>
